import React from 'react';

function Warning(props) {
    return (
    	<div className="warning-message error-card">
    		<div  className="alert-inline--warning">
    		</div>
			<div className="warning-body">
				<span className="dai_warningMessage">
					{props.children}
				</span>
			</div>
		</div>
    );
  };

export default Warning;  